import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsInlineSkateNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3.72 31.81a3.54 3.54 0 10-3.55-3.54 3.547 3.547 0 003.55 3.54zm0-5.43a1.89 1.89 0 110 3.78 1.89 1.89 0 010-3.78zm24.56-1.65a3.54 3.54 0 10.02 7.082 3.54 3.54 0 00-.02-7.082zm0 5.43a1.89 1.89 0 110-3.781 1.89 1.89 0 010 3.781zm-11.73-1.89a3.545 3.545 0 107.09.01 3.545 3.545 0 00-7.09-.01zm5.44 0a1.9 1.9 0 11-3.8.02 1.9 1.9 0 013.8-.02zm-13.63 0a3.545 3.545 0 107.09.01 3.545 3.545 0 00-7.09-.01zm5.44 0a1.9 1.9 0 11-3.801.02 1.9 1.9 0 013.801-.02zM1.35 21.53a5.053 5.053 0 003.88 1.8h21.02a4.238 4.238 0 004.23-4.23 3.313 3.313 0 00-1.75-2.92l-14.6-7.81.92-4.92A2.768 2.768 0 0012.33.17H9.55l-1.33 2H2.88L.24 17.4a5.061 5.061 0 001.11 4.13zm17.66-8.68l-1.66 3.19a.81.81 0 01-.71.43.811.811 0 01-.72-1.18l1.66-3.2 1.43.76zM1.86 17.68l.04-.21h3.04a4.342 4.342 0 014.09 2.91h1.72a6 6 0 00-5.81-4.56H2.18L4.27 3.83H9.1l1.34-2h1.89a1.114 1.114 0 011.1 1.32l-.3 1.59H9.12a2.455 2.455 0 100 4.91h3.89l3.11 1.66-1.66 3.22a2.455 2.455 0 104.36 2.26l1.63-3.16 4.08 2.17-2.38 4.58h1.86l1.98-3.8 1.96 1.05a1.657 1.657 0 01.88 1.47 2.586 2.586 0 01-2.58 2.58H5.23a3.42 3.42 0 01-3.37-4zM12.82 6.39L12.52 8h-3.4a.805.805 0 110-1.61h3.7z"
        fill=""
      />
    </svg>
  )
);
SvgSportsInlineSkateNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsInlineSkateNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsInlineSkateNormalMedium;
